import { takeEvery, put, call, all, fork } from "redux-saga/effects";
import {
  GET_INVOICE_LIST,
  GET_INVOICE_STATUS_LIST,
  GET_INVOICE_SINGLE_PDF,
  GET_SINGLE_INVOICE_DATA,
  CREATE_SINGLE_INVOICE_DATA,
  UPDATE_SINGLE_INVOICE_DATA,
  SEARCH_SINGLE_CUSTOMER_INVOICE_LIST,
  SEARCH_JOB_INVOICE_LIST,
  RESEND_INVOICE_EMAIL,
  SEND_INVOICE_EMAIL,
  VOID_INVOICE,
  REINVOICE,
  ADD_NEW_INVOICE_STATUS,
  DELETE_INVOICE_STATUS,
  UPDATE_INVOICE_STATUS,
  GET_INVOICE_PAYMENT_METHOD_LIST,
  ADD_NEW_INVOICE_PAYMENT_METHOD,
  DELETE_INVOICE_PAYMENT_METHOD,
  UPDATE_INVOICE_PAYMENT_METHOD,
  GET_MASTER_INVOICE_LIST,
  GET_MASTER_INVOICE_SINGLE_DATA,
  GET_CRMIT_INVOICE_PDF_SINGLE,
  GET_INVOICE_ITEM_LIST,
  GET_MASTER_INVOICE_LIST_CUSTOMER,
  SEARCH_INVOICE_ACTIVITY_LOG,
  SEARCH_INVOICE_ITEMS_LIST,
  GET_JOB_INVOICE_ITEM_TEMPLATE_LIST,
  GET_JOB_INVOICE_ITEM_TEMPLATE_DATA,
  SEARCH_JOB_INVOICE_ITEM_TEMPLATE,
  CREATE_JOB_INVOICE_ITEM_TEMPLATE,
  UPDATE_JOB_INVOICE_ITEM_TEMPLATE,
  DELETE_JOB_INVOICE_ITEM_TEMPLATE,
} from "./actionType";

import {
  getInvoiceListSuccess,
  getInvoiceListError,
  getInvoiceStatusListSuccess,
  getInvoiceStatusListError,
  getInvoiceSinglePDFSuccess,
  getInvoiceSinglePDFError,
  getSingleInvoiceDataSuccess,
  getSingleInvoiceDataError,
  createSingleInvoiceDataSuccess,
  createSingleInvoiceDataError,
  updateSingleInvoiceDataSuccess,
  updateSingleInvoiceDataError,
  searchSingleCustomerInvoiceListSuccess,
  searchSingleCustomerInvoiceListError,
  searchJobInvoiceListSuccess,
  searchJobInvoiceListError,
  resendInvoiceEmailSuccess,
  resendInvoiceEmailError,
  sendInvoiceEmailSuccess,
  sendInvoiceEmailError,
  voidInvoiceSuccess,
  voidInvoiceError,
  reinvoiceSuccess,
  reinvoiceError,
  addNewInvoiceStatusSuccess,
  addNewInvoiceStatusError,
  deleteInvoiceStatusSuccess,
  deleteInvoiceStatusError,
  updateInvoiceStatusSuccess,
  updateInvoiceStatusError,
  getInvoicePaymentMethodListSuccess,
  getInvoicePaymentMethodListError,
  addNewInvoicePaymentMethodSuccess,
  addNewInvoicePaymentMethodError,
  deleteInvoicePaymentMethodSuccess,
  deleteInvoicePaymentMethodError,
  updateInvoicePaymentMethodSuccess,
  updateInvoicePaymentMethodError,
  getMasterInvoiceListSuccess,
  getMasterInvoiceListError,
  getMasterInvoiceSingleDataSuccess,
  getMasterInvoiceSingleDataError,
  getCrmItInvoiceSingleDataSuccess,
  getCrmItInvoiceSingleDataError,
  getInvoiceItemListSuccess,
  getInvoiceItemListError,
  getMasterInvoiceListCustomerSuccess,
  getMasterInvoiceListCustomerError,
  searchInvoiceActivityLogSuccess,
  searchInvoiceActivityLogError,
  searchInvoiceItemsListSuccess,
  searchInvoiceItemsListError,
  getJobInvoiceItemTemplateListSuccess,
  getJobInvoiceItemTemplateListError,
  getJobInvoiceItemTemplateDataSuccess,
  getJobInvoiceItemTemplateDataError,
  searchJobInvoiceItemTemplateSuccess,
  searchJobInvoiceItemTemplateError,
  createJobInvoiceItemTemplateSuccess,
  createJobInvoiceItemTemplateError,
  updateJobInvoiceItemTemplateSuccess,
  updateJobInvoiceItemTemplateError,
  deleteJobInvoiceItemTemplateSuccess,
  deleteJobInvoiceItemTemplateError,
} from "./action";

import {
  getInvoiceList,
  getInvoiceStatusList,
  getSingleInvoicePDFData,
  getSingleInvoiceData,
  createSingleInvoiceData,
  updateSingleInvoiceData,
  searchSingleCustomerInvoiceList,
  resendInvoiceEmailApiCall,
  sendInvoiceEmailApiCall,
  voidInvoiceApiCall,
  reinvoiceApiCall,
  addNewInvoiceStatusApiCall,
  deleteInvoiceStatusApiCall,
  updateInvoiceStatusApiCall,
  getInvoicePaymentMethodListApiCall,
  addNewInvoicePaymentMethodApiCall,
  deleteInvoicePaymentMethodApiCall,
  updateInvoicePaymentMethodApiCall,
  getMasterInvoiceListApiCall,
  getMasterInvoiceSingleDataApiCall,
  getCrmItInvoiceSingleDataApiCall,
  getInvoiceItemListApiCall,
  getMasterInvoiceListCustomerApiCall,
  searchInvoiceActivityLogApiCall,
  searchInvoiceItemsListApiCall,
  getJobInvoiceItemTemplateListApiCall,
  getJobInvoiceItemTemplateDataApiCall,
  searchJobInvoiceItemTemplateApiCall,
  createJobInvoiceItemTemplateApiCall,
  updateJobInvoiceItemTemplateApiCall,
  deleteJobInvoiceItemTemplateApiCall,
} from "../../helpers/fakebackend_helper";

// get Invoice List
function* getInvoiceListItems() {
  try {
    const response = yield call(getInvoiceList);
    yield put(getInvoiceListSuccess(response));
  } catch (error) {
    yield put(getInvoiceListError(error));
  }
}

export function* watchGetInvoiceList() {
  yield takeEvery(GET_INVOICE_LIST, getInvoiceListItems);
}

// get Invoice Status List
function* getInvoiceStatusListItems() {
  try {
    const response = yield call(getInvoiceStatusList);
    yield put(getInvoiceStatusListSuccess(response));
  } catch (error) {
    yield put(getInvoiceStatusListError(error));
  }
}

// get Invoice Single PDF

function* getInvoiceSinglePDFItems({ payload }) {
  try {
    const response = yield call(getSingleInvoicePDFData, payload);
    yield put(getInvoiceSinglePDFSuccess(response));
  } catch (error) {
    yield put(getInvoiceSinglePDFError(error));
  }
}

export function* watchGetInvoiceSinglePDF() {
  yield takeEvery(GET_INVOICE_SINGLE_PDF, getInvoiceSinglePDFItems);
}

function* watchGetInvoiceStatusList() {
  yield takeEvery(GET_INVOICE_STATUS_LIST, getInvoiceStatusListItems);
}

// get Single Invoice Data
function* getSingleInvoiceDataItems({ payload }) {
  try {
    const response = yield call(getSingleInvoiceData, payload);
    yield put(getSingleInvoiceDataSuccess(response));
  } catch (error) {
    yield put(getSingleInvoiceDataError(error));
  }
}

// Create Single Invoice Data
function* createSingleInvoiceDataItems({ payload }) {
  try {
    const response = yield call(createSingleInvoiceData, payload);
    yield put(createSingleInvoiceDataSuccess(response));
  } catch (error) {
    yield put(createSingleInvoiceDataError(error));
  }
}

function* watchCreateSingleInvoiceData() {
  yield takeEvery(CREATE_SINGLE_INVOICE_DATA, createSingleInvoiceDataItems);
}

export function* watchGetSingleInvoiceData() {
  yield takeEvery(GET_SINGLE_INVOICE_DATA, getSingleInvoiceDataItems);
}

// update Single Invoice Data
function* updateSingleInvoiceDataItems({ payload }) {
  try {
    const response = yield call(updateSingleInvoiceData, payload);
    yield put(updateSingleInvoiceDataSuccess(response));
  } catch (error) {
    yield put(updateSingleInvoiceDataError(error));
  }
}

export function* watchUpdateSingleInvoiceData() {
  yield takeEvery(UPDATE_SINGLE_INVOICE_DATA, updateSingleInvoiceDataItems);
}

// search Single Customer Invoice List

function* searchSingleCustomerInvoiceListItems({ payload }) {
  try {
    const response = yield call(searchSingleCustomerInvoiceList, payload);

    yield put(searchSingleCustomerInvoiceListSuccess(response));
  } catch (error) {
    yield put(searchSingleCustomerInvoiceListError(error));
  }
}

export function* watchSearchSingleCustomerInvoiceList() {
  yield takeEvery(
    SEARCH_SINGLE_CUSTOMER_INVOICE_LIST,
    searchSingleCustomerInvoiceListItems
  );
}

// search Job Invoice List (single-job Invoices tab)
// Reuses the same POST /invoice/search endpoint helper but stores results in
// a dedicated slice so it never collides with the customer invoice tab.

function* searchJobInvoiceListItems({ payload }) {
  try {
    const response = yield call(searchSingleCustomerInvoiceList, payload);

    yield put(searchJobInvoiceListSuccess(response));
  } catch (error) {
    yield put(searchJobInvoiceListError(error));
  }
}

export function* watchSearchJobInvoiceList() {
  yield takeEvery(SEARCH_JOB_INVOICE_LIST, searchJobInvoiceListItems);
}

// resend Invoice Email

function* resendInvoiceEmailItems({ payload }) {
  try {
    const response = yield call(resendInvoiceEmailApiCall, payload);
    yield put(resendInvoiceEmailSuccess(response));
  } catch (error) {
    yield put(resendInvoiceEmailError(error));
  }
}

export function* watchResendInvoiceEmail() {
  yield takeEvery(RESEND_INVOICE_EMAIL, resendInvoiceEmailItems);
}

// send Invoice Email

function* sendInvoiceEmailItems({ payload }) {
  try {
    const response = yield call(sendInvoiceEmailApiCall, payload);
    yield put(sendInvoiceEmailSuccess(response));
  } catch (error) {
    yield put(sendInvoiceEmailError(error));
  }
}

export function* watchSendInvoiceEmail() {
  yield takeEvery(SEND_INVOICE_EMAIL, sendInvoiceEmailItems);
}

// void Invoice

function* voidInvoiceItems({ payload }) {
  try {
    const response = yield call(voidInvoiceApiCall, payload);
    yield put(voidInvoiceSuccess(response));
  } catch (error) {
    yield put(voidInvoiceError(error));
  }
}

export function* watchVoidInvoice() {
  yield takeEvery(VOID_INVOICE, voidInvoiceItems);
}

// re-invoice (void current invoice + generate a new one using today)

function* reinvoiceItems({ payload }) {
  try {
    const response = yield call(reinvoiceApiCall, payload);
    yield put(reinvoiceSuccess(response));
  } catch (error) {
    yield put(reinvoiceError(error));
  }
}

export function* watchReinvoice() {
  yield takeEvery(REINVOICE, reinvoiceItems);
}
// Add New Invoice Status

function* addNewInvoiceStatusItems({ payload }) {
  try {
    const response = yield call(addNewInvoiceStatusApiCall, payload);
    yield put(addNewInvoiceStatusSuccess(response));
  } catch (error) {
    yield put(addNewInvoiceStatusError(error));
  }
}

export function* watchAddNewInvoiceStatus() {
  yield takeEvery(ADD_NEW_INVOICE_STATUS, addNewInvoiceStatusItems);
}

// Delete Invoice Status

function* deleteInvoiceStatusItems({ payload }) {
  try {
    const response = yield call(deleteInvoiceStatusApiCall, payload);
    yield put(deleteInvoiceStatusSuccess(response));
  } catch (error) {
    yield put(deleteInvoiceStatusError(error));
  }
}

export function* watchDeleteInvoiceStatus() {
  yield takeEvery(DELETE_INVOICE_STATUS, deleteInvoiceStatusItems);
}

// Update Invoice Status

function* updateInvoiceStatusItems({ payload }) {
  try {
    const response = yield call(updateInvoiceStatusApiCall, payload);
    yield put(updateInvoiceStatusSuccess(response));
  } catch (error) {
    yield put(updateInvoiceStatusError(error));
  }
}

export function* watchUpdateInvoiceStatus() {
  yield takeEvery(UPDATE_INVOICE_STATUS, updateInvoiceStatusItems);
}

// Get Invoice Payment Method List

function* getInvoicePaymentMethodListItems() {
  try {
    const response = yield call(getInvoicePaymentMethodListApiCall);
    yield put(getInvoicePaymentMethodListSuccess(response));
  } catch (error) {
    yield put(getInvoicePaymentMethodListError(error));
  }
}

export function* watchGetInvoicePaymentMethodList() {
  yield takeEvery(
    GET_INVOICE_PAYMENT_METHOD_LIST,
    getInvoicePaymentMethodListItems
  );
}

// Add New Invoice Payment Method

function* addNewInvoicePaymentMethodItems({ payload }) {
  try {
    const response = yield call(addNewInvoicePaymentMethodApiCall, payload);
    yield put(addNewInvoicePaymentMethodSuccess(response));
  } catch (error) {
    yield put(addNewInvoicePaymentMethodError(error));
  }
}

export function* watchAddNewInvoicePaymentMethod() {
  yield takeEvery(
    ADD_NEW_INVOICE_PAYMENT_METHOD,
    addNewInvoicePaymentMethodItems
  );
}

// Delete Invoice Payment Method

function* deleteInvoicePaymentMethodItems({ payload }) {
  try {
    const response = yield call(deleteInvoicePaymentMethodApiCall, payload);
    yield put(deleteInvoicePaymentMethodSuccess(response));
  } catch (error) {
    yield put(deleteInvoicePaymentMethodError(error));
  }
}

export function* watchDeleteInvoicePaymentMethod() {
  yield takeEvery(
    DELETE_INVOICE_PAYMENT_METHOD,
    deleteInvoicePaymentMethodItems
  );
}

// Update Invoice Payment Method

function* updateInvoicePaymentMethodItems({ payload }) {
  try {
    const response = yield call(updateInvoicePaymentMethodApiCall, payload);
    yield put(updateInvoicePaymentMethodSuccess(response));
  } catch (error) {
    yield put(updateInvoicePaymentMethodError(error));
  }
}

export function* watchUpdateInvoicePaymentMethod() {
  yield takeEvery(
    UPDATE_INVOICE_PAYMENT_METHOD,
    updateInvoicePaymentMethodItems
  );
}

// Get Master Invoice List

function* getMasterInvoiceListItems() {
  try {
    const response = yield call(getMasterInvoiceListApiCall);
    yield put(getMasterInvoiceListSuccess(response));
  } catch (error) {
    yield put(getMasterInvoiceListError(error));
  }
}

export function* watchGetMasterInvoiceList() {
  yield takeEvery(GET_MASTER_INVOICE_LIST, getMasterInvoiceListItems);
}

// Get Master Invoice Single Data

function* getMasterInvoiceSingleDataItems({ payload }) {
  try {
    const response = yield call(getMasterInvoiceSingleDataApiCall, payload);
    yield put(getMasterInvoiceSingleDataSuccess(response));
  } catch (error) {
    yield put(getMasterInvoiceSingleDataError(error));
  }
}

export function* watchGetMasterInvoiceSingleData() {
  yield takeEvery(
    GET_MASTER_INVOICE_SINGLE_DATA,
    getMasterInvoiceSingleDataItems
  );
}

// Get CrmIt Invoice Single Data

function* getCrmItInvoiceSingleDataItems({ payload }) {
  try {
    const response = yield call(getCrmItInvoiceSingleDataApiCall, payload);
    yield put(getCrmItInvoiceSingleDataSuccess(response));
  } catch (error) {
    yield put(getCrmItInvoiceSingleDataError(error));
  }
}

export function* watchGetCrmItInvoiceSingleData() {
  yield takeEvery(GET_CRMIT_INVOICE_PDF_SINGLE, getCrmItInvoiceSingleDataItems);
}

// Get Invoice Item List

function* getInvoiceItemListItems() {
  try {
    const response = yield call(getInvoiceItemListApiCall);
    yield put(getInvoiceItemListSuccess(response));
  } catch (error) {
    yield put(getInvoiceItemListError(error));
  }
}

export function* watchGetInvoiceItemList() {
  yield takeEvery(GET_INVOICE_ITEM_LIST, getInvoiceItemListItems);
}

// Get Master Invoice List Customer

function* getMasterInvoiceListCustomerItems({ payload }) {
  try {
    const response = yield call(getMasterInvoiceListCustomerApiCall, payload);
    yield put(getMasterInvoiceListCustomerSuccess(response));
  } catch (error) {
    yield put(getMasterInvoiceListCustomerError(error));
  }
}

export function* watchGetMasterInvoiceListCustomer() {
  yield takeEvery(
    GET_MASTER_INVOICE_LIST_CUSTOMER,
    getMasterInvoiceListCustomerItems
  );
}

// Search Invoice Activity Log

function* searchInvoiceActivityLogItems({ payload }) {
  try {
    const response = yield call(searchInvoiceActivityLogApiCall, payload);
    yield put(searchInvoiceActivityLogSuccess(response));
  } catch (error) {
    yield put(searchInvoiceActivityLogError(error));
  }
}

export function* watchSearchInvoiceActivityLog() {
  yield takeEvery(SEARCH_INVOICE_ACTIVITY_LOG, searchInvoiceActivityLogItems);
}

// Search Invoice Items List

function* searchInvoiceItemsListItems({ payload }) {
  try {
    const response = yield call(searchInvoiceItemsListApiCall, payload);
    yield put(searchInvoiceItemsListSuccess(response));
  } catch (error) {
    yield put(searchInvoiceItemsListError(error));
  }
}

export function* watchSearchInvoiceItemsList() {
  yield takeEvery(SEARCH_INVOICE_ITEMS_LIST, searchInvoiceItemsListItems);
}

// Get Job Invoice Item Template List

function* getJobInvoiceItemTemplateListItems() {
  try {
    const response = yield call(getJobInvoiceItemTemplateListApiCall);
    yield put(getJobInvoiceItemTemplateListSuccess(response));
  } catch (error) {
    yield put(getJobInvoiceItemTemplateListError(error));
  }
}

export function* watchGetJobInvoiceItemTemplateList() {
  yield takeEvery(
    GET_JOB_INVOICE_ITEM_TEMPLATE_LIST,
    getJobInvoiceItemTemplateListItems
  );
}

// Get Job Invoice Item Template Data

function* getJobInvoiceItemTemplateDataItems({ payload }) {
  try {
    const response = yield call(getJobInvoiceItemTemplateDataApiCall, payload);
    yield put(getJobInvoiceItemTemplateDataSuccess(response));
  } catch (error) {
    yield put(getJobInvoiceItemTemplateDataError(error));
  }
}

export function* watchGetJobInvoiceItemTemplateData() {
  yield takeEvery(
    GET_JOB_INVOICE_ITEM_TEMPLATE_DATA,
    getJobInvoiceItemTemplateDataItems
  );
}

// Search Job Invoice Item Template

function* searchJobInvoiceItemTemplateItems({ payload }) {
  try {
    const response = yield call(searchJobInvoiceItemTemplateApiCall, payload);
    yield put(searchJobInvoiceItemTemplateSuccess(response));
  } catch (error) {
    yield put(searchJobInvoiceItemTemplateError(error));
  }
}

export function* watchSearchJobInvoiceItemTemplate() {
  yield takeEvery(
    SEARCH_JOB_INVOICE_ITEM_TEMPLATE,
    searchJobInvoiceItemTemplateItems
  );
}

// Create Job Invoice Item Template

function* createJobInvoiceItemTemplateItems({ payload }) {
  try {
    const response = yield call(createJobInvoiceItemTemplateApiCall, payload);
    yield put(createJobInvoiceItemTemplateSuccess(response));
  } catch (error) {
    yield put(createJobInvoiceItemTemplateError(error));
  }
}

export function* watchCreateJobInvoiceItemTemplate() {
  yield takeEvery(
    CREATE_JOB_INVOICE_ITEM_TEMPLATE,
    createJobInvoiceItemTemplateItems
  );
}

// Update Job Invoice Item Template

function* updateJobInvoiceItemTemplateItems({ payload }) {
  try {
    const response = yield call(updateJobInvoiceItemTemplateApiCall, payload);
    yield put(updateJobInvoiceItemTemplateSuccess(response));
  } catch (error) {
    yield put(updateJobInvoiceItemTemplateError(error));
  }
}

export function* watchUpdateJobInvoiceItemTemplate() {
  yield takeEvery(
    UPDATE_JOB_INVOICE_ITEM_TEMPLATE,
    updateJobInvoiceItemTemplateItems
  );
}

// Delete Job Invoice Item Template

function* deleteJobInvoiceItemTemplateItems({ payload }) {
  try {
    const response = yield call(deleteJobInvoiceItemTemplateApiCall, payload);
    yield put(deleteJobInvoiceItemTemplateSuccess(response));
  } catch (error) {
    yield put(deleteJobInvoiceItemTemplateError(error));
  }
}

export function* watchDeleteJobInvoiceItemTemplate() {
  yield takeEvery(
    DELETE_JOB_INVOICE_ITEM_TEMPLATE,
    deleteJobInvoiceItemTemplateItems
  );
}

function* InvoiceCrmITSaga() {
  yield all([
    fork(watchGetInvoiceList),
    fork(watchGetInvoiceStatusList),
    fork(watchGetInvoiceSinglePDF),
    fork(watchGetSingleInvoiceData),
    fork(watchCreateSingleInvoiceData),
    fork(watchUpdateSingleInvoiceData),
    fork(watchSearchSingleCustomerInvoiceList),
    fork(watchSearchJobInvoiceList),
    fork(watchResendInvoiceEmail),
    fork(watchSendInvoiceEmail),
    fork(watchVoidInvoice),
    fork(watchReinvoice),
    fork(watchAddNewInvoiceStatus),
    fork(watchDeleteInvoiceStatus),
    fork(watchUpdateInvoiceStatus),
    fork(watchGetInvoicePaymentMethodList),
    fork(watchAddNewInvoicePaymentMethod),
    fork(watchDeleteInvoicePaymentMethod),
    fork(watchUpdateInvoicePaymentMethod),
    fork(watchGetMasterInvoiceList),
    fork(watchGetMasterInvoiceSingleData),
    fork(watchGetCrmItInvoiceSingleData),
    fork(watchGetInvoiceItemList),
    fork(watchGetMasterInvoiceListCustomer),
    fork(watchSearchInvoiceActivityLog),
    fork(watchSearchInvoiceItemsList),
    fork(watchGetJobInvoiceItemTemplateList),
    fork(watchGetJobInvoiceItemTemplateData),
    fork(watchSearchJobInvoiceItemTemplate),
    fork(watchCreateJobInvoiceItemTemplate),
    fork(watchUpdateJobInvoiceItemTemplate),
    fork(watchDeleteJobInvoiceItemTemplate),
  ]);
}

export default InvoiceCrmITSaga;
